import React, { lazy, Suspense } from "react";

import { useSelector } from "react-redux";
import "./footer.scss";

const MobileFooter = lazy(() => import("./MobileFooter"));
const FooterDesktop = lazy(() => import("./FooterDesktop"));

export default function Footer() {
  const isLsm = useSelector((state) => state.deviceSize.isLsm);

  return <Suspense>{isLsm ? <MobileFooter /> : <FooterDesktop />}</Suspense>;
}
